const MEDIA_ORIGIN = 'https://js0rh0olrc2l6ccysulgm8fc4s5g4b.aydawcux16rbjxf5ufl5c6y.ru';

export const toSameOriginMediaUrl = (value) => {
    if (typeof value !== 'string') {
        return value;
    }

    if (value.startsWith(`${MEDIA_ORIGIN}/uploads/`)) {
        return value.replace(`${MEDIA_ORIGIN}/uploads/`, '/media/');
    }

    return value;
};

export const normalizeMediaUrls = (value) => {
    if (typeof value === 'string') {
        return toSameOriginMediaUrl(value);
    }

    if (Array.isArray(value)) {
        return value.map(normalizeMediaUrls);
    }

    if (value && typeof value === 'object') {
        Object.keys(value).forEach((key) => {
            value[key] = normalizeMediaUrls(value[key]);
        });
    }

    return value;
};

export const toProductThumbnailUrl = (value, width = 360) => {
    const sameOriginUrl = toSameOriginMediaUrl(value);

    if (typeof sameOriginUrl !== 'string' || !sameOriginUrl.startsWith('/media/')) {
        return sameOriginUrl;
    }

    const relativePath = sameOriginUrl.slice('/media/'.length);
    if (!/\.(jpe?g|png|webp)$/i.test(relativePath)) {
        return sameOriginUrl;
    }

    const safeWidth = Math.max(120, Math.min(720, Number(width) || 360));
    const encodedPath = relativePath
        .split('/')
        .map((part) => {
            try {
                return encodeURIComponent(decodeURIComponent(part));
            } catch (error) {
                return encodeURIComponent(part);
            }
        })
        .join('/');

    return `/thumb.php?w=${safeWidth}&path=${encodedPath}`;
};
